import { Controller } from "@hotwired/stimulus";

// Package (Pakettjänster) selection in step3/_packages.html.erb. Each
// radio carries data-product-code so this controller can tell the "no
// service" (NONE) package apart from a real one, matching the original's
// `.service-item-button-NONE` class check.
export default class extends Controller {
  static targets = ["commentWith", "commentWithout"];

  select(event) {
    const isNone = event.target.dataset.productCode === "NONE";
    this.commentWithTarget.classList.toggle("hidden", isNone);
    this.commentWithoutTarget.classList.toggle("hidden", !isNone);

    this.element.dispatchEvent(new CustomEvent("package:changed", { bubbles: true }));
  }
}
